import React, { useEffect, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import usePageTitle from '../../hooks/usePageTitle';
import { ServicesList } from './ServicesList';
import { ServicesGraph } from '../../components/ServicesGraph';
import useLocalizedCopy from '../../hooks/useLocalizedCopy';
import { usePageHeader } from '../../contexts/PageHeaderContext';
import { useAuth } from '../../AuthContext';

interface ServicesRoutesProps {
    viewType?: 'list' | 'dashboard';
}

export function ServicesRoutes({ viewType = 'list' }: ServicesRoutesProps) {
    const { copy } = useLocalizedCopy();
    const location = useLocation();
    const { setPageHeader } = usePageHeader();
    const { viewingAllAccounts } = useAuth();
    
    usePageTitle(copy.Services.list.title);
    
    const isListView = viewType === 'list';
    const isDashboardView = viewType === 'dashboard';

    // Create navigation items with useMemo to prevent recreating on every render
    const navigationItems = useMemo(() => (
        <div className="flex gap-4 text-sm">
            <Link 
                to="/services/list" 
                className={isListView ? "text-primary font-semibold" : "text-gray-600 hover:text-primary"}
            >
                List View
            </Link>
            <Link 
                to="/services/dashboard"
                className={isDashboardView ? "text-primary font-semibold" : "text-gray-600 hover:text-primary"}
            >
                Dashboard
            </Link>
        </div>
    ), [isListView, isDashboardView]);

    useEffect(() => {
        setPageHeader(copy.Services.list.title, navigationItems);
        
        return () => setPageHeader(null);
    }, [copy.Services.list.title, navigationItems, setPageHeader]);

    return (
        <div className="container-fixed">
            {isListView ? <ServicesList /> : <ServicesGraph />}
        </div>
    );
}